export default __webpack_public_path__ + "media/Bamboo_left.0b4d3955780d7cdb0781b706efcf4105.svg";